export const headersNames = {
    TOKEN: 'X-Token',
};
